<template>
  <div class="channel-class-container">
    <div class="video-play-box">
      <video id="video2" class="video-js vjs-default-skin vjs-big-play-centered" preload="auto" x5-playsinline="true" webkit-playsinline="true" playsinline="true" >
          <source id="sourceBox" src="https://service.ivydad.com/tmp/ivy/knowlege/audio/681ab3b606a1e042900a6f50b4d5ed38/ivy.m3u8" type='application/x-mpegURL'>
      </video>
    </div>
    <div class="header">
      <span class="title">{{detail.course_state}}</span>
      <div class="rule" @click="toggleOrder">
        <img src="../../assets/icons/decs.png" v-show="orderBy == 'DESC'"/>
        <img src="../../assets/icons/asc.png" v-show="orderBy == 'ASC'"/>
      </div>
      <!-- <div class="rule" @click="toApp">
        <img src="../../assets/icons/download.png" class="download" />
      </div> -->
    </div>
    <ul class="list"
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="noMore"
        infinite-scroll-distance="10">
      <channelClassItem v-for="(item, index) in list" :key="item.id" :item="item" :curIndex="curIndex" :index="index" :rate="rate" :hasBought="hasBought" @toPlayPage="toPlayPage(item, index)" @playAudio="playAudio" @pauseAudio="pauseAudio"></channelClassItem>
    </ul>
    <noData v-if="!list.length" text="专栏暂无课程，敬请期待"></noData>
  </div>
</template>
<script>
import axios from 'axios'
import channelClassItem from './channelClassItem'
import noData from '../comps/noData'
import * as util from '../../util'
import videojs from 'video.js'
import AudioPromise from '@ivy/fts/audioPromise'
import openApp from '@ivy/fts/openApp'
let audioPromise = null
export default {
  props: ["id", "hasBought", "isLimitFree", "detail"],
  data() {
    return {
      orderBy: 'DESC',
      noMore: false,
      list: [],
      limit: 10,
      curPage: 1,
      video: '',
      curIndex: -1,
      pausedIndx: -1,
      rate: 0,
      playAudioTimer: '',
      currentTime: '',
      hasAccountFinish: false
    }
  },
  components: {
    channelClassItem,
    noData
  },
  created() {
    this.orderBy = 'DESC'
  },
  mounted() {
    this.video = videojs('video2')
    this.video.on("timeupdate", e => {
      let duration = this.video.duration()
      let currentTime = this.video.currentTime()
      let rate = Math.floor((currentTime / duration) * 100)
      this.rate = rate >= 0 ? rate : 0
    })
    this.video.on("ended", e => {
      this.playNext()
    })
  },
  beforeDestroy() {
    this.pauseAudio()
    this.video.pause()
    this.video && this.video.dispose()
  },
  computed: {
    hasAccess() {
      return this.hasBought || this.isLimitFree
    }
  },
  methods: {
    toggleOrder() {
      this.orderBy = this.orderBy === 'DESC' ? 'ASC' : 'DESC'
      this.list = []
      this.noMore = false
      this.curPage = 1
      this.pauseAudio()
      this.pausedIndx = -1
      this.loadMore()
    },
    async loadMore() {
      if (this.$parent.selected === 'detail') return
      this.noMore = true
      let r = await axios.get('/api/mobile/knowlege/course/getCourseLessonList', {
        params: {id: this.id, limit: this.limit, offset: this.list.length, orderBy: this.orderBy, isNew: 1}
      })
      // this.curPage = this.curPage + 1
      this.noMore = !r.data.length
      r.data.forEach((item, index) => {
        r.data[index] = {
          ...r.data[index],
          cover: util.transAliImgResize(item.pic_url || item.cover, 180, 180)}
      })
      this.list = [...this.list, ...r.data]
    },
    async toPlayPage(item, index) {
      console.log(item)
      if (!this.hasBought && !item.is_try) return this.$Toast({message: `购买才能观看哦！`, iconClass: "error-tip"})
      if (item.is_lock !== 0) return this.$Toast({message: `课程未解锁，解锁后才能学习哦！`})
      item.type === 'audio' && await this.playAudio(index)
      this.$emit("toPlayPage", item)
    },
    async playAudio(index) {
      this.pauseAudio()
      if (!this.hasAccess && !this.list[index].is_try) return this.$Toast({message: `购买后才能观看哦~`, iconClass: 'error-tip'})
      let isMp3 = /.mp3$/.test(this.list[index].lesson_url)
      if (+index !== this.pausedIndx) {
        this.currentTime = 0
        this.hasAccountFinish = false
        if (!isMp3) {
          this.video.src({type: 'application/x-mpegURL', src: this.list[index].lesson_url})
          this.video.load()
        } else {
          // this.$Indicator.open('资源加载中')
          if (!audioPromise) {
            audioPromise = new AudioPromise(this.list[index].lesson_url, e => this.updateTime(e), e => this.updateStatus(e))
          } else {
            audioPromise.info.src = this.list[index].lesson_url
          }
        }
        axios.post('/api/mobile/knowlege/uti/updateLessonPlayCount', { lessonId: this.list[index].id }, {disableLoading: true})
      }
      this.curIndex = +index
      this.pausedIndx = +index
      isMp3 ? audioPromise.play(this.currentTime || 0) : this.video.play()
    },
    pauseAudio() {
      if (this.curIndex === -1) return
      /.mp3$/.test(this.list[this.curIndex].lesson_url) ? audioPromise.pause() : this.video.pause()
      this.curIndex = -1
    },
    updateTime(e) {
      // this.$Indicator.close()
      let duration = e.target.duration
      this.currentTime = e.target.currentTime
      let rate = Math.floor((e.target.currentTime / duration) * 100)
      this.rate = rate >= 0 ? rate : 0
      if (+rate >= 85 && !this.hasAccountFinish) {
        this.hasAccountFinish = true
        axios.post('/api/mobile/knowlege/uti/accountLessonStatistics', { lessonId: this.list[this.curIndex].id, courseId: this.list[this.curIndex].course_id, type: 'play_finish' }, {disableLoading: true})
      }
      if (rate === 100) this.playNext()
    },
    updateStatus(e) {
    },
    playNext() {
      this.rate = 0
      let curIndex = this.curIndex
      if (curIndex === this.list.length - 1 || this.list[curIndex + 1].type !== 'audio' || !this.hasAccess || +this.list[curIndex + 1].is_lock) {
        this.curIndex = -1
        this.pausedIndx = -1
      } else {
        this.playAudio(curIndex + 1)
      }
    },
    async beforeDestroy() {
      audioPromise && await audioPromise.pause()
    },
    toApp() {
      openApp('readtool')
    },
    async toTryListenPage() {
      if (!this.list || !this.list.length) {
        await this.loadMore()
      }
      this.toPage()
    },
    async toPage() {
      let item = this.list[0]
      if (!item) return
      if (item.is_lock !== 0) return this.$Toast({message: `课程未解锁，解锁后才能学习哦！`})
      item.type === 'audio' && await this.playAudio(index)
      this.$emit("toPlayPage", item)
    }
  }
}
</script>
<style lang="less" scoped>
  @import url('../../common.less');
  .channel-class-container {
    .pad30-lr;
    .header {
      .display-flex;
      justify-content: space-between;
      align-items: center;
      font-size: .71rem;
      .vux-1px-b;
      .pad30-tb;
      .title{
        font-family: PingFangSC-Semibold;
        font-size: .82rem;
        color: #1A1A1A;
        flex: 1;
      }
      .rule {
        position: relative;
        font-size:.88rem;
        img {
          display: block;
          width: 1.29rem;
          height: 1.29rem;
          &.download {
            margin-left: 1.76rem;
          }
        }
      }
    }
    .list {
      .pad30-tb;
    }
    .video-play-box {
      position: absolute;
      left: 0;
      top: 0;
      width: 1px;
      height: 1px;
      overflow: hidden;
      .video-js {
        position: absolute;
        left: -500px;
        top: -500px;
        width: 100%;
        height: 100%;
      }
    }
  }
</style>
